import { ThunkDispatch } from "core-integration/src/store";
import { unbanLeagueEntry } from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Button from "../../Button";
import SubHeading from "../../SubHeading";

interface IOwnProps {
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const RemoveBan: React.FC<Props> = ({ t, league }) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useNavigate();

  if (!league.bans.length) {
    return null;
  }

  const handleOnClick = async (leagueId: number, entryId: number) => {
    await dispatch(unbanLeagueEntry(leagueId, { entry: entryId }));
    navigate("/leagues");
  };

  return (
    <>
      <SubHeading>
        {t("removeBan.title", "Remove league suspensions")}
      </SubHeading>
      <p>
        {t(
          "removeBan.description",
          "If a player has a suspension removed, they will need to join the league again.",
        )}
      </p>
      <ul>
        {league.bans.map((b) => (
          <li key={b.entry}>
            {b.player_name}
            <Button onClick={() => handleOnClick(league.id, b.entry)}>
              {t("removeBan.suspendPlayer", "Remove suspension")}
            </Button>
          </li>
        ))}
      </ul>
    </>
  );
};

export default withTranslation()(RemoveBan);
